module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"members":"Members","search":"Search"},"th":{"members":"สมาชิก","search":"ค้นหา"}}')
  delete Component.options._Ctor
}
